import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { FooterMode } from '@/store/ui';
import { RETRO_CREDIT_COMPLETED_STATES } from '@/store/retro-credit';
import { Routes } from '@/router';

@Component({
    name: 'CmgRetroCreditPage',
    beforeRouteLeave(to, from, next) {
        // If we haven't selected a restaurant yet, just let them nav away
        if (!this.$appStore.state.retroCredit.selectedRestaurant || RETRO_CREDIT_COMPLETED_STATES.includes(this.$appStore.state.retroCredit.state)) {
            this.$services.ui.popFooterState();
            next();

            return;
        }

        // Otherwise, pop the confirmation modal
        this.$services.ui.setModalVisibility('retroCreditConfirmNavModal', true, {
            onConfirm: () => {
                this.$services.ui.popFooterState();
                next();
            },
            onCancel: () => {
                next(false);
            },
        });
        this.$services.ui.firstFocus();
    },
})
export default class CmgRetroCreditPage extends Vue {
    async mounted() {
        const isLoggedIn = await this.$services.customer.waitForCustomerInitialization();
        if (!isLoggedIn) {
          window.location.replace(`${window.location.origin}${this.$services.config.getRewardsPath()}`);
          return;
        }
        if (!this.$services.loyalty.isLoyaltyEligible(this.$appStore.state.customer.profile)) {
          this.$router.replace({ name: Routes.Rewards });
          return;
        }

        this.$services.retroCredit.reset();

        this.$services.ui.pushFooterState({ mode: FooterMode.Micro });
    }
}
